import { Injectable } from '@angular/core';
import { BaseWidgetFactory } from '../../widget-factory';
import type { JsxgraphStatic } from './jsxgraph.model';
import { JsxgraphService } from './jsxgraph-loader.service';
import { JsxgraphBaseWidget } from './jsxgraph-widget-base';
import { JsxgraphThemeService } from './jsxgraph-theme.service';

/**
 * JSXGraph-specific constructor interface for creating widget instances.
 * Enforces the constructor signature: (container, jsxInstance, themeService)
 */
export interface JsxgraphWidgetConstructor {
  new (container: HTMLElement, jsxInstance: JsxgraphStatic, themeService: JsxgraphThemeService): JsxgraphBaseWidget;
}

// JSXGraph-specific implementation of the widget factory.
// Creates and manages JSXGraph-based widget instances.
// TExtraArgs is [JsxgraphStatic] - the framework instance passed to create() after container.
@Injectable()
export class JsxgraphWidgetFactoryService extends BaseWidgetFactory<JsxgraphWidgetConstructor, [JsxgraphStatic]> {
  constructor(
    private readonly themeService: JsxgraphThemeService,
    private readonly jsxService: JsxgraphService,
  ) {
    super();
  }

  // JSXGraph-specific: instantiate widget with jsxInstance and themeService.
  protected override instantiate(
    WidgetClass: JsxgraphWidgetConstructor,
    container: HTMLElement,
    jsxInstance: JsxgraphStatic,
  ): JsxgraphBaseWidget {
    return new WidgetClass(container, jsxInstance, this.themeService);
  }

  override async loadFramework(): Promise<JsxgraphStatic> {
    return await this.jsxService.loadJsxgraph();
  }
}
